/* global rp$, globalThis */

const THE_SCRIPT = function() {
	const $onReady = require('public/js/lib/on-ready');

	function getProductsPerPage($container) {
		const productsPerPage = globalThis.getComputedStyle($container[0])
			.getPropertyValue('--products-per-page')
			.trim();
		return parseInt(productsPerPage, 10) || 2;
	}

	function init() {
		const $specialOffers = rp$('.special-offers');

		if (!$specialOffers.length) {
			return;
		}

		$specialOffers.each(function() {
			const $container = rp$(this);
			const $itemsContainer = $container.find('.special-offers-items');
			const $items = $itemsContainer.find('.special-offer-card');
			const $navContainer = $container.find('.special-offers-navigation');

			const totalProducts = $items.length;
			let currentPage = 0;
			let productsPerPage = getProductsPerPage($itemsContainer);
			let totalPages = Math.ceil(totalProducts / productsPerPage);

			// Show products for a specific page and update navigation state
			function showPage(pageIndex) {
				const startIndex = pageIndex * productsPerPage;
				const endIndex = startIndex + productsPerPage;

				// Hide all products and show only the products for the current page
				$items.addClass('hidden');
				$items.slice(startIndex, endIndex).removeClass('hidden');

				// Update the active navigation dot
				const $allDots = $container.find('.special-offer-nav-dot');
				$allDots.removeClass('active');
				const $activeDot = $allDots.eq(pageIndex);
				if ($activeDot.length) {
					$activeDot.addClass('active');
				}

				// Update arrow button states
				const $allNavLeft = $container.find('.special-offer-nav-arrow-left');
				const $allNavRight = $container.find('.special-offer-nav-arrow-right');
				$allNavLeft.prop('disabled', pageIndex === 0);
				$allNavRight.prop('disabled', pageIndex >= totalPages - 1);
			}

			// Setup pagination based on current screen size
			function setupPagination() {
				const newProductsPerPage = getProductsPerPage($itemsContainer);
				const newTotalPages = Math.ceil(totalProducts / newProductsPerPage);

				// Update page count and adjust current page if needed
				if (productsPerPage === newProductsPerPage) {
					totalPages = newTotalPages;
				} else {
					const firstVisibleIndex = currentPage * productsPerPage;
					productsPerPage = newProductsPerPage;
					totalPages = newTotalPages;
					currentPage = Math.min(Math.floor(firstVisibleIndex / productsPerPage), totalPages - 1);
				}

				// Generate navigation if multiple pages
				if (totalPages > 1) {
					$navContainer.removeClass('hidden').empty();

					// Add left arrow from template
					const leftArrowTemplate = globalThis.document.getElementById('special-offer-nav-arrow-left-template');
					if (leftArrowTemplate) {
						const leftArrow = leftArrowTemplate.content.cloneNode(true);
						$navContainer.append(leftArrow);
					}

					// Add navigation dots for each page
					const dotTemplate = globalThis.document.getElementById('special-offer-nav-dot-template');
					for (let i = 0; i < totalPages; i++) {
						if (dotTemplate) {
							const dot = dotTemplate.content.cloneNode(true);
							const $dot = rp$(dot.querySelector('button'));
							$dot.attr('data-slide', i);
							$dot.attr('aria-label', 'Go to slide ' + (i + 1));
							if (i === currentPage) {
								$dot.addClass('active');
							}
							$navContainer.append($dot);
						}
					}

					// Add right arrow from template
					const rightArrowTemplate = globalThis.document.getElementById('special-offer-nav-arrow-right-template');
					if (rightArrowTemplate) {
						const rightArrow = rightArrowTemplate.content.cloneNode(true);
						$navContainer.append(rightArrow);
					}

					// Attach click handlers to navigation elements
					const $newNavLeft = $container.find('.special-offer-nav-arrow-left');
					const $newNavRight = $container.find('.special-offer-nav-arrow-right');
					const $newNavDots = $container.find('.special-offer-nav-dot');

					const leftHandler = function() {
						if (currentPage > 0) {
							currentPage--;
							showPage(currentPage);
						}
					};
					const rightHandler = function() {
						if (currentPage < totalPages - 1) {
							currentPage++;
							showPage(currentPage);
						}
					};
					const dotHandler = function() {
						currentPage = Number.parseInt(rp$(this).data('slide'), 10);
						showPage(currentPage);
					};

					$newNavLeft.on('click', leftHandler);
					$newNavRight.on('click', rightHandler);
					$newNavDots.on('click', dotHandler);

					// Show initial page
					showPage(currentPage);
				} else {
					// Show all products and hide navigation if only one page
					$items.removeClass('hidden');
					$navContainer.addClass('hidden');
				}
				$itemsContainer.removeClass('hidden');
			}

			// Handle window resize events
			const resizeObserver = new ResizeObserver(function() {
				setupPagination();
			});
			resizeObserver.observe($itemsContainer[0]);

			// Initialize pagination
			setupPagination();
		});
	}

	$onReady({
		rp$,
		window: globalThis,
		label: 'single_sku_cross_sell',
		fn: function() { init(); },
	});
};

try {
	if (__CURRENT_SCRIPT__ === undefined) {
		throw new TypeError('__CURRENT_SCRIPT__ is not defined');
	}
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	// Fallback: execute script directly if __CURRENT_SCRIPT__ is not available
	THE_SCRIPT();
}
